import styled from 'styled-components';
import {
  v2Breakpoints, v2Colors, v2FontFamily, v2ReadableFontFamily,
} from './styles/tokens';

export const TableScroll = styled.div`
  max-width: 800px;
  margin: 10px auto 0;
  overflow-x: auto;
  border: 1px solid ${v2Colors.border};
  border-radius: 14px;
  -webkit-overflow-scrolling: touch;

  scrollbar-width: thin;
  scrollbar-color: ${v2Colors.textFaint} transparent;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${v2Colors.textFaint};
    border-radius: 4px;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: ${v2ReadableFontFamily};

  th,
  td {
    padding: 8px 10px;
    white-space: nowrap;
    border-bottom: 1px solid ${v2Colors.border};
  }

  thead th {
    font-family: ${v2FontFamily};
    font-size: 12px;
    font-weight: 700;
    color: ${v2Colors.textMuted};
    background: ${v2Colors.surface};
    text-align: center;
    white-space: nowrap;
  }

  tbody th,
  tbody td {
    font-size: 13px;
    color: ${v2Colors.text};
  }

  tbody td {
    text-align: center;
  }

  tbody tr:last-child th,
  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:nth-child(even) {
    background: ${v2Colors.surface};
  }

  th:first-child,
  td:first-child {
    position: sticky;
    left: 0;
    z-index: 1;
    background: ${v2Colors.inputBackground};
    text-align: left;
    white-space: normal;
    min-width: 180px;
    max-width: 240px;
    box-shadow: 1px 0 0 ${v2Colors.border};
  }

  tbody tr:nth-child(even) th:first-child,
  tbody tr:nth-child(even) td:first-child {
    background: ${v2Colors.surface};
  }

  @media (max-width: ${v2Breakpoints.tablet}) {
    th,
    td {
      padding: 7px 8px;
    }

    thead th {
      font-size: 12.5px;
    }

    tbody th,
    tbody td {
      font-size: 13.5px;
    }

    th:first-child,
    td:first-child {
      min-width: 150px;
      max-width: 190px;
    }
  }
`;
